import React from 'react'
import { graphql, Link } from 'gatsby';
import Container from '../../components/Container/Container';
import './Blog-template.scss';
import Contact from '../../components/Contact/Contact';
import { IoMdArrowRoundBack } from 'react-icons/io';

const blog_template = ({ data:{blog:{createdAt, title, id, overview, author, content}} }) => {
    
    return (
        <div className='blog_template'>
            <Container>
                <div className='blog_template_inner'>
                <div className='titleContainer'>
                    <Link to='/blog/' ><IoMdArrowRoundBack className='icon'/></Link>
                    <h1 className='title'>{title}</h1> 
                </div>
                <p className='createdAt'>Published By: {author}</p>
                <p className='createdAt'>{createdAt}</p>
                <div className='overview'>
                    <h3>Overview</h3>
                    <p>{overview}</p>
                </div>
                <div className='content' dangerouslySetInnerHTML={{__html: content.childMarkdownRemark.html}}>
                </div>
                <div className='footer'>
                <Contact />
                <p>Designed and Developed by Philane Msibi. { new Date().getFullYear() }</p>
                </div>
                </div>
                
            </Container>
        </div>
    )
}

export const result = graphql`
query GetBlog($slug: String) {
    blog:contentfulBlog(slug: {eq: $slug}) {
      createdAt(formatString: "MMMM Do, YYYY")
      title
      id
      overview
      slug
      author
      content {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`

export default blog_template
